import { createEffect, Show, Suspense, useContext } from "solid-js";
import { AppControllerContext } from "./AppControllerContext";
import { MarketplaceSelectorCardComponent } from "./MarketplaceSelectorCardComponent";
import { Footer } from "./Footer";
import { Loading } from "./Loading";
import { createAsync } from "@solidjs/router";
export function MarketplaceSelectorPage() {
    console.log("Rendering MarketplaceSelectorPage");
    const appController = useContext(AppControllerContext);
    if (appController) {
        const getMarketplaces = createAsync(async () => {
            const getMarketplacesResponse = await appController.authenticatedFunctionsApi.invokeQuery("Marketplaces/GetMarketplaces", {});
            const marketplaces = getMarketplacesResponse.Items.$values.map(x => x.AggregateRootWithPrivacyAuthorizationFilterResult.AggregateRootWithPrivacyFilterApplied);
            return marketplaces;
        });
        createEffect(() => {
            const marketplaces = getMarketplaces();
            if (marketplaces && marketplaces.length === 0) {
                appController.showVenueSelector();
            }
        });
        return (<div id="marketplace-selector" style="height: 100vh; display: flex; flex-direction: column; gap: 1rem; justify-content: center; align-items: center;">
                <div style="font-size: 4rem; color: var(--emsurge-dark-background); margin-bottom: 3rem;">
                    Select Marketplace
                </div>
                <Suspense fallback={<Loading resourceName={"marketplaces"}/>}>
                    <div style="display: flex; flex-direction: column; gap: 2rem;">
                        {getMarketplaces()?.map(x => <MarketplaceSelectorCardComponent marketplace={x}/>)}
                    </div>
                </Suspense>
                <Show when={appController.userSession.getUserVenuesIds().length > 0}>
                    <div style="margin-top: 6rem">
                        <button style="background: var(--emsurge-golden-bright-color); padding: 2rem; border-radius: 3rem; width: 30vw; font-size:3rem" onclick={appController.showVenueSelector}>
                            Other Emsurge Venues
                        </button>
                    </div>
                </Show>
                <Footer />
            </div>);
    }
    else {
        throw "appController from context is undefined!";
    }
}
